// ----------------------------------------------------------------------

export default function Link() {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
        color: 'secondary.dark'
      },
    },
  };
}
